import mitt from "mitt";

const eventEmitter = mitt();

export default eventEmitter;
